window.__NM_SHAMPOO_GIFT_V2 = true;

(function () {
  const MAIN_VARIANT_IDS = new Set([42345176825933, 42439465599053]);
  const GIFT_VARIANT_ID = 42351497019469;
  let internalAdd = false;
  let syncing = false;

  function drawerRoot() {
    return document.querySelector("#CartDrawer .drawer__inner") || document.querySelector("#CartDrawer");
  }

  function showBanner() {
    const host = drawerRoot();
    if (!host) return;
    let banner = document.querySelector("#freebie-status-banner");
    if (!banner) {
      banner = document.createElement("div");
      banner.id = "freebie-status-banner";
      banner.textContent = "🎁 Adding your free gifts…";
      const body = host.querySelector(".cart-drawer__body") || host;
      body.prepend(banner);
    }
    banner.classList.add("visible");
    banner.setAttribute("aria-hidden", "false");
    const skeleton = document.querySelector("#freebie-skeleton-container");
    if (skeleton) {
      skeleton.classList.add("active");
      skeleton.querySelectorAll(".freebie-skeleton").forEach(function (row) {
        row.classList.add("active");
      });
    }
  }

  function hideBanner() {
    document.querySelectorAll("#freebie-status-banner").forEach(function (banner) {
      banner.classList.remove("visible");
      banner.setAttribute("aria-hidden", "true");
    });
    const skeleton = document.querySelector("#freebie-skeleton-container");
    if (skeleton) {
      skeleton.classList.remove("active");
      skeleton.querySelectorAll(".freebie-skeleton").forEach(function (row) {
        row.classList.remove("active");
      });
    }
  }

  function selectedVariantId(target) {
    const form =
      (target && target.closest && target.closest("form")) ||
      document.querySelector('product-form form, form[action*="/cart/add"]');
    const input = form && form.querySelector('[name="id"]');
    return Number(input && input.value);
  }

  function readCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (res) {
      return res.json();
    });
  }

  function syncShampooGift() {
    if (syncing || internalAdd || window.__nmBlockAutoGiftAdds) return Promise.resolve();
    syncing = true;
    return readCart()
      .then(function (cart) {
        const hasMain = cart.items.some(function (item) {
          return MAIN_VARIANT_IDS.has(item.variant_id);
        });
        const gift = cart.items.find(function (item) {
          return item.variant_id === GIFT_VARIANT_ID;
        });
        if (hasMain && gift) {
          window.__nmShampooGiftPending = false;
          hideBanner();
          return null;
        }
        if (hasMain && !gift) {
          window.__nmShampooGiftPending = true;
          showBanner();
          internalAdd = true;
          return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }),
            })
            .then(function () {
              if (typeof window.refreshCartDrawer === "function") return window.refreshCartDrawer();
            })
            .then(function () {
              window.__nmShampooGiftPending = false;
              hideBanner();
            })
            .finally(function () {
              internalAdd = false;
            });
        }
        if (!hasMain && gift) {
          return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: gift.key, quantity: 0 }),
            })
            .then(function () {
              window.__nmShampooGiftPending = false;
              hideBanner();
              if (typeof window.refreshCartDrawer === "function") return window.refreshCartDrawer();
            });
        }
        if (!window.__nmShampooGiftPending) hideBanner();
        return null;
      })
      .catch(function (err) {
        console.error("[Shampoo gift]", err);
      })
      .finally(function () {
        syncing = false;
      });
  }

  document.addEventListener(
    "pointerdown",
    function (event) {
      const button = event.target.closest("button, input[type='submit']");
      if (!button) return;
      if (!button.closest("product-form, .product-form, form[action*='/cart/add']")) return;
      if (!MAIN_VARIANT_IDS.has(selectedVariantId(button))) return;
      window.__nmShampooGiftPending = true;
      showBanner();
      let tries = 0;
      const timer = window.setInterval(function () {
        tries += 1;
        if (!window.__nmShampooGiftPending || tries > 15) {
          window.clearInterval(timer);
          if (tries > 15) {
            window.__nmShampooGiftPending = false;
            hideBanner();
          }
          return;
        }
        syncShampooGift();
      }, 400);
    },
    true,
  );

  document.addEventListener("cart:updated", syncShampooGift);
  document.addEventListener("cart:refresh", syncShampooGift);

  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    new MutationObserver(function () {
      if (drawer.classList.contains("active") && window.__nmShampooGiftPending) {
        showBanner();
        syncShampooGift();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }
})();
